import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=d010b698&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d010b698",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d010b698')) {
      api.createRecord('d010b698', component.options)
    } else {
      api.reload('d010b698', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=d010b698&scoped=true&", function () {
      api.rerender('d010b698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mvkpnBfAgwUw/JS/comp/Accordion.vue"
export default component.exports